export default {
  name: 'Actions',
  edit: {
    form: 'action-input',
    label: 'Add Actions',
    prepare: action => action,
    handler: value => value,
  },
};
